import React from 'react';
import PageLayout from '../../components/PageLayout';
import PageHero from '../../components/PageHero';
import Button from '../../components/Button';

const BREADCRUMBS = [
  { label: 'Home', to: '/' },
  { label: 'Donations', to: '/donations/donations-at-ifys' },
  { label: 'Donations at IFYS' },
];

const DonationsAtIfysPage = () => {
  return (
    <PageLayout activeLink="donations">
      <PageHero
        title="Donations at IFYS"
        backgroundImage="/images/service-headers/donate%201.jpg"
        breadcrumbs={BREADCRUMBS}
        variant="split"
      />

      <section className="bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 md:py-20">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-ifys-blue mb-6 tracking-tight">
            Inclusive Kids
          </h2>

          <div className="space-y-6 text-gray-700 leading-relaxed text-base sm:text-lg">
            <p>
              Since its establishment in 2010, Inclusive Kids, a fund of IFYS has committed immense effort to alleviate
              the distress experienced by underprivileged children. Since it&apos;s inception, Inclusive Kids has successfully
              raised and, more importantly, redistributed over $1,485,881.22 in support to inclusive for children and
              young people.
            </p>
            <p>
              Whilst this is an impressive amount of funds to raise and give back, it is important to acknowledge there
              is still much more that needs to be done to support children in need.
            </p>
            <p>
              If you believe in the future of Australian children and aspire to positively impact their lives,
              particularly those who are unintentionally excluded from community involvement, we kindly request your
              consideration in donating to Inclusive Kids today.
            </p>
          </div>

          <div className="mt-12">
            <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-ifys-blue leading-tight tracking-tight">
              Let us work together to ensure that children are fully embraced within our communities.
            </h3>

            <div className="mt-8 flex items-center gap-5 flex-wrap">
              <Button
                href="https://www.inclusivekids.com.au/donate"
                target="_blank"
                rel="noopener noreferrer"
                variant="primary"
                size="md"
              >
                Donate now
              </Button>

              <div className="flex items-center gap-3">
                <a
                  href="https://www.facebook.com/ifysqld/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center w-10 h-10 rounded-full text-ifys-blue bg-ifys-blue/10 hover:bg-ifys-blue hover:text-white transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-ifys-blue focus-visible:ring-offset-2"
                  aria-label="IFYS Ltd on Facebook"
                  title="IFYS Ltd on Facebook"
                >
                  <svg className="w-[18px] h-[18px]" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/ifysqld/?hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center w-10 h-10 rounded-full text-ifys-blue bg-ifys-blue/10 hover:bg-ifys-blue hover:text-white transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-ifys-blue focus-visible:ring-offset-2"
                  aria-label="IFYS Ltd on Instagram"
                  title="IFYS Ltd on Instagram"
                >
                  <svg className="w-[18px] h-[18px]" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.077-4.358.2-6.78 2.618-6.98 6.98-.063 1.281-.077 1.689-.077 4.948 0 3.259.014 3.668.077 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.063 1.689.077 4.948.077 3.259 0 3.668-.014 4.948-.077 4.354-.2 6.782-2.618 6.979-6.98.063-1.281.077-1.689.077-4.948 0-3.259-.014-3.667-.077-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.063-1.69-.078-4.949-.078zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="relative bg-ifys-light-gray overflow-hidden border-t border-gray-200">
        <img
          src="/images/image.png"
          alt=""
          aria-hidden
          loading="lazy"
          className="hidden md:block absolute -top-40 -left-40 w-80 h-80 object-cover rounded-full pointer-events-none opacity-90"
        />
        <img
          src="/images/image.png"
          alt=""
          aria-hidden
          loading="lazy"
          className="hidden md:block absolute -bottom-40 -right-40 w-80 h-80 object-cover rounded-full pointer-events-none opacity-90"
        />

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 md:py-20 relative z-10">
          <div className="space-y-4 text-gray-700 text-sm sm:text-base leading-relaxed">
            <p>
              If you wish to donate something other than money, such as property, goods or services, please contact IFYS
              on 07 5438 3000 or email: donations@ifys.com.au
            </p>
            <p>
              IFYS endeavours to create and operate a strong culture of compliance regarding all our financial
              responsibilities and requirements.
            </p>
            <p>
              IFYS enlists the services of independent auditors and we abide by the guidelines and the recommendations
              endorsed by the Australian Taxation Office.
            </p>
            <p>
              We have Endorsement for Deductible Gift Recipient (DGR) status and we have an Endorsement for Tax
              Deductibility Concessions. We are also a registered charity in every state of Australia.
            </p>
            <p className="pt-2 text-gray-600">ABN: 69 131 388 102</p>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default DonationsAtIfysPage;
